<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="close()"> <ion-icon slot="icon-only" name="close"></ion-icon> </ion-button>
    </ion-buttons>
    <ion-title>{{ title || ('saga.attachmenttype.picture' | translate) }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false" fullscreen="true">
  <div class="image-container">
    <img [src]="imageUrl | secure | async" alt="{{ 'loading...' | translate }}" />
  </div>
</ion-content>
